module.exports = __webpack_public_path__ + "static/DY5-c6fcf16a9f093a03cd84e5e6eceef665.jpg";